import React, { useState } from "react";
import { Link } from "react-router-dom";

import "../../assets/styles/card/newProductCard.scss";

//  $$ Icons $$  \\
import { PiShoppingCartBold } from "react-icons/pi";
import { HiOutlineShieldCheck } from "react-icons/hi";
import { FaHeart } from "react-icons/fa";

// Images \\
import officeAv from "../../assets/images/chickenAvatar.jpeg";

const ChickenCard = (props) => {
  const [liked, setLiked] = useState(false);

  const handleToggle = () => {
    setLiked((prevState) => !prevState);
  };

  const data = props.data;
  return (
    <div>
      <div className="cardType  mb-20" id={props.data.id}>
        <div className="card_items">
          <Link>
            <div className="card_items_img ">
              <figure>
                <img className="productsImg" src={officeAv} alt="T_shirt" />
              </figure>
            </div>
          </Link>
          <div className="card_items_content bg-[#a09d9d]">
            <div className="prices flex gap-2">
              <div className="check_icon">
                <HiOutlineShieldCheck className=" text-xl" />
              </div>
              <div className=" w-full flex justify-between">
                <p className="product_name">
                  <span className="">{data.color} </span>
                  {data.name}
                </p>
                <p>
                  <span className="priceSpan">{data.price}</span> сум
                </p>
              </div>
            </div>

            <div className="hr  w-full my-6"></div>

            <div className="buttons flex items-center my-6 justify-between">
              <div className="icons flex items-center gap-8 just">
                <div className={`like toggle ${liked ? "liked" : ""}`}>
                  <FaHeart className="likeHeart " onClick={handleToggle} />
                </div>

                <div className="shoppingCard">
                  <PiShoppingCartBold className="shoppngCardIcon text-[32px]" />
                </div>
              </div>

              <div className="seeMore">
                <Link className="link">See More</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChickenCard;
